import { createReducer } from 'typesafe-actions';

import { TCryptoAction, EncryptionActionTypes, ICryptoState } from '@/store/types/encryption.types';

const initialState: ICryptoState = {
  isLoading: false,
  endUsersKeyPair: {},
};

export const encryptionReducer = createReducer<ICryptoState, TCryptoAction>(initialState)
  .handleType(EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS, (state, action) => ({
    ...state,
    globalSupportPairKey: {
      privateKey: state.globalSupportPairKey?.privateKey || '',
      publicKey: action.globalSupportPublicKey,
    },
    isLoading: false,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.FETCH_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY_SUCCESS, (state, action) => ({
    ...state,
    globalSupportPairKey: {
      privateKey: state.globalSupportPairKey?.privateKey || '',
      publicKey: action.globalSupportPublicKey,
    },
    isLoading: false,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.SET_GLOBAL_SUPPORT_PUBLIC_KEY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY_SUCCESS, (state, action) => ({
    ...state,
    supportUserPairKey: action.supportUserPairKey,
    isLoading: false,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.FETCH_SUPPORT_USER_ENCRYPTED_KEY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY_SUCCESS, (state, action) => {
    return {
      ...state,
      endUsersKeyPair: { ...state.endUsersKeyPair, [action.userId]: action.userPairKey },
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(EncryptionActionTypes.FETCH_USER_DECRYPTED_KEY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(EncryptionActionTypes.SET_GLOBAL_SUPPORT_PAIR_KEY, (state, action) => ({
    ...state,
    globalSupportPairKey: { ...state.globalSupportPairKey, ...action.globalSupportPairKey },
  }))

  .handleType(EncryptionActionTypes.SET_SUPPORT_USER_PAIR_KEY, (state, action) => ({
    ...state,
    supportUserPairKey: { ...state.supportUserPairKey, ...action.supportUserPairKey },
  }))

  .handleType(EncryptionActionTypes.ADD_USER_PAIR_KEY, (state, action) => {
    return {
      ...state,
      endUsersKeyPair: { ...state.endUsersKeyPair, [action.userId]: action.userPairKey },
    };
  });
